import { BaseBlock } from "./BaseBlock";

export class AccountTitleBlock extends BaseBlock {

    private root!: HTMLElement;

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "sticker-card account-card";

        this.root.innerHTML = `
            <h2>
                Мій акаунт
            </h2>
        `;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}